export default __webpack_public_path__ + "static/media/certifypk.c244fab0.webp";